module.exports = __webpack_public_path__ + "media/images/icons/country_flags/mz-fa69ce647848a8178798a91da7876551.svg";